import { useMemo } from 'react'
import { useSelector } from 'react-redux'

import { selectVisibleCockpitPartnerData } from 'partner360/features/financialCockpit/model/selectors'

/** Display name for each partner id — what the hierarchy tables' dimension columns need to label
 *  their `level: 'partner'` leaves, which carry the raw `PartnerId` rather than a baked-in label
 *  (see `IRevenueAndSobHierarchyNode.partnerId`). The offering counterpart of
 *  `useOfferingNameByCode`, resolved the same way.
 *
 *  Read from `selectVisibleCockpitPartnerData` rather than the full partner list: in manager mode
 *  that is the filtered set `selectVisibleCockpitFinSobRows` narrows the tree's own rows to, so the
 *  map can't name a partner the tree doesn't show, or miss one it does. */
export const usePartnerNameById = (): Map<string, string> => {
  const partnerData = useSelector(selectVisibleCockpitPartnerData)

  return useMemo(
    () => new Map(partnerData.map(({ PartnerId, PartnerName }) => [PartnerId, PartnerName])),
    [partnerData]
  )
}
